import { resourceReducer } from '../../utils/resourceReducer';

// Create actions and a reducer for the investmentStrategyDocuments resource
export const [actions, reducer, resourceSagas] = resourceReducer(
  'investment-strategy-documents'
);

export const sagas = resourceSagas;
